import { Component, Input } from '@angular/core';
import { Day } from 'src/main/webapp/assets/models/iter.model';

/**ToDo Documentazione */
@Component({
  selector: 'app-sistemazioni',
  styleUrls: ['./sistemazioni.component.scss'],
  templateUrl: './sistemazioni.component.html'
})
export class SistemazioniComponent {
  @Input() public days: Day[] = [];
  @Input() public showOptionlServices: any;
  @Input() public noImageUrl: any;
  @Input() public defaultImage: any;
  @Input() public replaceShowDescriptionButtonWithNotes: boolean = false;
  @Input() public hideMedia: boolean = false;
  @Input() public serviceIcons: any;

  public IsFirstTimeHotel(index: number): boolean {
    if (
      index > 0 &&
      this.days[index]?.hotels[0]?.hotels[0]?.code !==
        this.days[index - 1]?.hotels[0]?.hotels[0]?.code
    ) {
      return true;
    }

    return false;
  }
}
